import { Link } from "react-router-dom";
import { Button } from "components/ui";

const getBadgeClass = (status) => {
  if (["completed", "partially_completed"].includes(status)) return "badge-success";
  if (status === "failed") return "badge-danger";
  return "badge-warning";
};

export default function ImportDetailHeader({
  backTo,
  backLabel,
  iconClass,
  title,
  status,
  statusLabel,
  metadata = [],
  stats = [],
  progress = null,
  actions = null,
  testIdPrefix = "",
}) {
  const visibleMetadata = metadata.filter(item => item?.value !== null && item?.value !== undefined && item?.value !== "");
  const visibleStats = stats.filter(item => item?.value !== null && item?.value !== undefined && item?.value !== "");
  const progressValue = progress === null ? null : Math.min(Math.max(Math.round(progress), 0), 100);

  return (
    <div className="mb-4" data-testid={`${testIdPrefix}import-detail-header`}>
      {backTo && backLabel && (
        <Button as={Link} variant="ghost" size="inline" icon="bi-arrow-left" to={backTo} className="mb-3" data-testid={`${testIdPrefix}back-link`}>
          {backLabel}
        </Button>
      )}

      <div className="border rounded px-4 py-4 bg-light">
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
          <div className="pr-lg-3">
            <div className="d-flex flex-wrap align-items-center">
              <i className={`${iconClass} mr-2 h4 mb-0`}></i>
              <h3 className="mb-0" data-testid={`${testIdPrefix}import-title`}>{title}</h3>
              {status && (
                <span className={`badge ${getBadgeClass(status)} ml-3`} data-testid={`${testIdPrefix}import-status`}>{statusLabel}</span>
              )}
            </div>

            {visibleMetadata.length > 0 && (
              <div className="mt-3 d-flex flex-wrap text-muted">
                {visibleMetadata.map((item, index) => (
                  <span key={`${item.label}-${index}`} className={`mr-4 ${index > 0 ? "mt-2 mt-sm-0" : ""}`}>
                    <span className="font-weight-bold">{item.label}:</span> {item.value}
                  </span>
                ))}
              </div>
            )}
          </div>

          {actions && (
            <div className="mt-3 mt-lg-0" data-testid={`${testIdPrefix}import-actions`}>{actions}</div>
          )}
        </div>

        {progressValue !== null && (
          <div className="mt-4">
            <div className="progress" style={{ height: "8px" }} data-testid={`${testIdPrefix}import-progress`}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: `${progressValue}%` }}
                aria-valuenow={progressValue}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <small className="text-muted d-block mt-1">{progressValue}%</small>
          </div>
        )}

        {visibleStats.length > 0 && (
          <div className="row mt-4">
            {visibleStats.map((item, index) => (
              <div key={`${item.label}-${index}`} className="col-md-4 mb-3 mb-md-0">
                <div className="bg-white border rounded p-3 h-100">
                  <div className={`h4 mb-1 ${item.valueClassName || ""}`}>{item.value}</div>
                  <small className="text-muted">{item.label}</small>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
